import styles from './../promotion/promotion.module.scss'
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { compare, formatCash } from 'utils'
import { IMAGE_DEFAULT, PERMISSIONS, ROUTES } from 'consts'
import { useHistory } from 'react-router-dom'

import {
  Popconfirm,
  Input,
  Button,
  Row,
  Col,
  Select,
  Table,
  notification,
  Drawer,
  Form,
  Switch,
  Space,
} from 'antd'
import { DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons'

//components
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
import FilterRegion from 'components/filter-region'
import Permission from 'components/permission'

//apis
import { getBranches } from 'apis/branch'
import { apiAllEmployee } from 'apis/employee'
import { getPromotions, updatePromotion, deletePromotion } from 'apis/promotion'

const { Option } = Select
export default function Promotion() {
  const dispatch = useDispatch()
  const history = useHistory()
  const typingTimeoutRef = useRef(null)

  const [countPromotion, setCountPromotion] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [promotions, setPromotions] = useState()
  const [listBranch, setListBranch] = useState([])
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')
  const [userList, setUserList] = useState([])

  const columnsPromotion = [
    {
      width: 60,
      title: 'STT',
      render: (data, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Hình ảnh',
      render: (data, record) => (
        <img
          style={{ width: 80, height: 80 }}
          alt=""
          src={(record.image_urls.length && record.image_urls[0]) || IMAGE_DEFAULT}
        />
      ),
    },
    {
      title: 'CTKM',
      sorter: (a, b) => compare(a, b, 'name'),
      render: (text, record, index) => (
        <div>
          <div>{record.name}</div>
          <Permission permissions={[PERMISSIONS.cap_nhat_chuong_trinh_khuyen_mai]}>
            <div
              onClick={() => history.push(ROUTES.PROMOTION_UPDATE + `?id=${record.promotion_id}`)}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <EditOutlined
                style={{ color: '#6074E2', fontSize: 14, cursor: 'pointer', alignSelf: 'center' }}
              />
              <a style={{ width: 100, fontSize: 14 }}>{'Cập nhật'}</a>
            </div>
          </Permission>
        </div>
      ),
    },
    {
      title: 'Mô tả',
      sorter: (a, b) => compare(a, b, 'description'),
      render: (data, record) => <div>{data.description}</div>,
    },
    {
      title: 'Loại khuyến mãi',
      dataIndex: 'type',
      render(data) {
        return data == 'percent' ? 'Phần trăm' : 'Giá trị'
      },
      sorter: (a, b) => compare(a, b, 'type'),
    },
    {
      title: 'Giá trị khuyến mãi',
      dataIndex: 'value',
      render(data, record) {
        if (record.type.toLowerCase() === 'value') return formatCash(data.toString()) + ' VND'
        return formatCash(data.toString()) + '%'
      },
      sorter: (a, b) => compare(a, b, 'value'),
    },
    {
      title: 'Người tạo',
      dataIndex: 'creator_info',
      render: (text, record) => record.creator_info && text.full_name,
      sorter: (a, b) =>
        (a.creator_info && a.creator_info.full_name).length -
        (b.creator_info && b.creator_info.full_name).length,
    },
    {
      title: 'Số lượng khuyến mãi',
      dataIndex: 'total_promotion',
      sorter: (a, b) => compare(a, b, 'total_promotion'),
    },
    {
      title: 'Quốc gia',
      render: (text, record) =>
        record.country_info && record.country_info.map((branch) => branch.name).join(', '),
    },
    {
      title: 'Khu vực',
      render: (text, record) =>
        record.region_info && record.region_info.map((branch) => branch.name).join(', '),
    },
    {
      title: 'Chi nhánh',
      render: (text, record) =>
        record.branch_info && record.branch_info.map((branch) => branch.name).join(', '),
    },
    {
      title: 'Ngày bắt đầu',
      render: (text, record) => `${record.start_date} ${record.start_hour}`,
    },
    {
      title: 'Ngày kết thúc',
      render: (text, record) => `${record.end_date} ${record.end_hour}`,
    },
    {
      title: '',
      dataIndex: 'is_active',
      render(data, record) {
        return (
          <Space>
            <Switch
              checked={data}
              onChange={(e) => _updatePromotion(record.promotion_id, { is_active: e })}
            />

            <Popconfirm
              onConfirm={() => _deletePromotion(record.promotion_id)}
              title="Bạn có muốn xóa chương trình khuyến mãi này không?"
            >
              <Button type="primary" icon={<DeleteOutlined />} danger />
            </Popconfirm>
          </Space>
        )
      },
    },
  ]

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const onFilters = (attribute = '', value = '') => {
    if (value) paramsFilter[attribute] = value
    else delete paramsFilter[attribute]
    setParamsFilter({ ...paramsFilter })
  }

  const _updatePromotion = async (id, body) => {
    try {
      dispatch({ type: 'LOADING', data: true })
      const res = await updatePromotion(id, body)
      if (res.status === 200) {
        form.resetFields()
        _getPromotions()
        notification.success({ message: 'Cập nhật chương trình khuyến mãi thành công' })
      } else
        notification.error({
          message:
            res.data.message || 'Cập nhật chương trình khuyến mãi thất bại, vui lòng thử lại',
        })
      dispatch({ type: 'LOADING', data: false })
    } catch (e) {
      console.log(e)
      dispatch({ type: 'LOADING', data: false })
    }
  }

  const _deletePromotion = async (id) => {
    try {
      setLoading(true)
      const res = await deletePromotion([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa chương trình khuyến mãi thành công' })
          _getPromotions()
        } else
          notification.error({ message: 'Xóa chương trình khuyến mãi thất bại, vui lòng thử lại' })
      } else
        notification.error({ message: 'Xóa chương trình khuyến mãi thất bại, vui lòng thử lại' })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getUserList = async () => {
    try {
      const res = await apiAllEmployee({ page: 1, page_size: 1000 })
      if (res.status === 200) {
        if (res.data.success) {
          setUserList(res.data.data)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const _getPromotions = async () => {
    try {
      setLoading(true)
      const res = await getPromotions({ ...paramsFilter, _creator: true })
      console.log(res)
      if (res.status === 200) {
        setPromotions(res.data.data)
        setCountPromotion(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setListBranch(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    _getBranches()
    _getUserList()
  }, [])

  useEffect(() => {
    _getPromotions()
  }, [paramsFilter])

  return (
    <>
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <TitlePage title="Chương trình khuyến mãi">
          <Permission permissions={[PERMISSIONS.them_chuong_trinh_khuyen_mai]}>
            <Button
              onClick={() => history.push(ROUTES.PROMOTION_CREATE)}
              icon={<PlusCircleOutlined style={{ fontSize: '1rem' }} />}
              type="primary"
              size="large"
            >
              Tạo khuyến mãi
            </Button>
          </Permission>
        </TitlePage>

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Input
              prefix={<SearchOutlined />}
              size="large"
              placeholder="Tìm kiếm khuyến mãi"
              onChange={onSearch}
              allowClear
              value={valueSearch}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <FilterDate
              placeholder="Lọc theo thời gian tạo"
              size="large"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Select
              size="large"
              style={{ width: '100%' }}
              allowClear
              placeholder="Lọc theo hình thức khuyến mãi"
              value={paramsFilter.type}
              onChange={(value) => onFilters('type', value)}
            >
              <Option value="percent">Phần trăm</Option>
              <Option value="value">Giá trị</Option>
            </Select>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Select
              size="large"
              style={{ width: '100%' }}
              allowClear
              placeholder="Tìm kiếm theo người tạo"
              value={paramsFilter.creator_id}
              onChange={(value) => onFilters('creator_id', value)}
              showSearch
            >
              {userList.map((item) => {
                return (
                  <Option value={item.user_id}>
                    {item.first_name} {item.last_name}
                  </Option>
                )
              })}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <FilterRegion
              width_size="100%"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
        </Row>

        <div
          style={{
            width: '100%',
            marginTop: '1rem',
            border: '1px solid rgb(243, 234, 234)',
          }}
        >
          <Table
            style={{ width: '100%' }}
            size="small"
            rowKey="promotion_id"
            loading={loading}
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countPromotion,
            }}
            columns={columnsPromotion}
            dataSource={promotions}
            scroll={{ y: 500 }}
          />
        </div>
      </div>
    </>
  )
}
